<template>
  <div class="live-top top-bg">
    <div class="top-bar bar">
      <ul>
        <li class="user-info">
          <!-- todo: 暂时去除 -->
          <!-- <img
            :src="$store.state.userInfo.avatarUrl"
            @click="showUserPop"
          > -->
          <van-image
            :src="$store.state.userInfo.avatarUrl"
            @click="handleClickAvatar"
          >
            <template v-slot:error>
              <img
                src="@/assets/icon/avatar.png"
                alt=""
              >
            </template>
            <template v-slot:loading>
              <van-loading
                type="spinner"
                size="20"
              />
            </template>
          </van-image>
          <div>
            <p :class="type ==='app' ? 'app-width':''">
              <span class="font11 clamp1">
                {{$store.state.userInfo.nickName}}
              </span>
            </p>
            <p :class="type ==='app' ? 'app-width':''">
              <span class="font10 clamp1">
                ID: {{$store.state.userInfo.userNo || $store.state.userInfo.userId}}
              </span>
            </p>
          </div>
          <!-- todo: 暂时去除 -->
          <!-- <div
            class="follow"
            @click="handleClickFollow"
            v-if="!isFollow && type !== 'app'"
          >
            关注
          </div> -->
        </li>
        <li class="font10 num">人气 {{viewReport}}</li>
        <!-- todo: 暂时去除 -->
        <!-- <li
          class="openApp"
          @click="$openApp"
          v-if="type!=='app'"
        >打开微医直播</li> -->
      </ul>
    </div>
    <div class="followPop-mask">
      <van-overlay
        :show="popHeight !== 0"
        @click.stop="popHeight=0"
        :z-index="1000004"
      >
      </van-overlay>
      <followPop
        :popHeight="popHeight"
        :isFollow="isFollow"
      />
    </div>

  </div>
</template>
<script>
import followPop from './follow-pop/index.vue';

export default {
  props: {
    viewReport: [Number, String],
    type: [String],
    isFollow: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    followPop,
  },
  data() {
    return {
      popHeight: 0,
    };
  },
  methods: {
    handleClickAvatar() {
      if (this.$store.state.userInfo.expertUrl) {
        this.$player.pause();
        window.location.href = this.$store.state.userInfo.expertUrl;
      }
    },
    handleClickFollow() {
      if (this.type !== 'app') {
        this.$openApp();
      }
      this.$emit('clickFollow');
    },
    showUserPop() {
      if (this.type !== 'app') {
        this.popHeight = this.popHeight ? 0 : 6;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.top-bar {
  font-size: 12px;
  padding: 15px 5px;
  top: 0;
  right: 0;
  left: 0;
  text-shadow: none;
  ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    li {
      background: rgba(0, 0, 0, 0.4);
      border-radius: 20px;
    }
    .user-info {
      display: flex;
      align-items: center;
      padding: 0 2px;
      height: 32px;
      .follow {
        background: #ef425a;
        height: 25px;
        position: relative;
        padding: 0 7px;
        padding-left: 25px;
        line-height: 25px;
        background: linear-gradient(90deg,#f6327e, #ff2553);
        border-radius: 18px;
      }
      .follow::after{
        content: "";
        display: block;
        background-image: url('../../../assets/img/live/follow.png');
        background-size: 100%;
        width: 20px;
        height: 20px;
        position: absolute;
        top: 2px;
        left: 4px;
      }
      .van-image {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        overflow: hidden;
      }
      div {
        margin-left: 2px;
        .font10 {
          margin-top: 1px;
        }
        .app-width {
          max-width: 200px;
        }
        p{
          max-width: 80px;
          >span{
            width: 100%;
          }
        }
      }
    }
    .num {
      padding: 5px 12px;
    }
    .openApp{
      font-size: 16px;
      color: #ffffff;
      background: linear-gradient(#95b7ff, #4f79ff);
      border-radius: 18px;
      padding: 0 10px;
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
